export const LOAD_REPORT = 'LOAD_REPORT';
export const LOAD_REPORT_SUCCESS = 'LOAD_REPORT_SUCCESS';
export const LOAD_REPORT_FAILURE = 'LOAD_REPORT_FAILURE';
export const LOAD_ALLDEAL_REPORT = 'LOAD_ALLDEAL_REPORT';
export const LOAD_ALLDEAL_REPORT_SUCCESS = 'LOAD_ALLDEAL_REPORT_SUCCESS';
export const LOAD_ALLDEAL_REPORT_FAILURE = 'LOAD_ALLDEAL_REPORT_FAILURE';
export const LOAD_SOA_REPORT = 'LOAD_SOA_REPORT';
export const LOAD_SOA_REPORT_SUCCESS = 'LOAD_SOA_REPORT_SUCCESS';
export const LOAD_SOA_REPORT_FAILURE = 'LOAD_SOA_REPORT_FAILURE';
export const LOAD_ONLINE_REPORT = 'LOAD_ONLINE_REPORT';
export const LOAD_ONLINE_REPORT_SUCCESS = 'LOAD_ONLINE_REPORT_SUCCESS';
export const LOAD_ONLINE_REPORT_FAILURE = 'LOAD_ONLINE_REPORT_FAILURE';
export const LOAD_MARGIN='LOAD_MARGIN';
export const LOAD_MARGIN_SUCCESS='LOAD_MARGIN_SUCCESS';
export const LOAD_MARGIN_FAILURE='LOAD_MARGIN_FAILURE';
export const EXPORT_ALLDEAL_REPORT = 'EXPORT_ALLDEAL_REPORT';
export const EXPORT_SOA_REPORT = 'EXPORT_SOA_REPORT';
export const EXPORT_POSITION_REPORT = 'EXPORT_POSITION_REPORT';
export const LOAD_ACTIVITY_REPORT='LOAD_ACTIVITY_REPORT';
export const LOAD_ACTIVITY_REPORT_SUCCESS='LOAD_ACTIVITY_REPORT_SUCCESS';
export const LOAD_ACTIVITY_REPORT_FAILURE='LOAD_ACTIVITY_REPORT_FAILURE';
export const EXPORT_ACTIVITY_REPORT='EXPORT_ACTIVITY_REPORT';
export const EXPORT_INVOICE_REPORT = 'EXPORT_INVOICE_REPORT';
export const RESET_STATE = 'RESET_STATE';
export const RESET_REPORT_STATE = 'RESET_REPORT_STATE';
export const EXPORT_ORDER_HISTORY_REPORT = 'EXPORT_ORDER_HISTORY_REPORT';
export const EXPORT_ONLINE_ORDER_REPORT = 'EXPORT_ONLINE_ORDER_REPORT';
export const EXPORT_BM_REPORT='EXPORT_BM_REPORT';
export const LOAD_BENCHMARK_REPORT='LOAD_BENCHMARK_REPORT';
export const LOAD_BENCHMARK_REPORT_SUCCESS='LOAD_BENCHMARK_REPORT_SUCCESS';
export const LOAD_BENCHMARK_REPORT_FAILURE='LOAD_BENCHMARK_REPORT_FAILURE';
export const ENABLE_LOADER='ENABLE_LOADER';
export const MODAL_FLAG='MODAL_FLAG';
export const DATE_RANGE_DAYS = 180;
